import { Flex, Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import type { ISitelink } from '../AdStep.types';

import * as styles from '../AdStep.css';

interface IAdGroupSitelinksProps {
  sitelinks: ISitelink[];
}

/**
 * A read-only list of an ad group's sitelinks for the collapsed summary. The URL is the
 * part the ad previews below can't show.
 *
 * @param props - {@link IAdGroupSitelinksProps}.
 */
function AdGroupSitelinks({ sitelinks }: Readonly<IAdGroupSitelinksProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  if (!sitelinks.length) {
    return <Text.SmallRegular>{t('None yet.')}</Text.SmallRegular>;
  }

  return (
    <Stack gap={theme.spacing.half}>
      {sitelinks.map((sitelink) => (
        <Flex gap={theme.spacing['2']} key={sitelink.key} wrap={'wrap'}>
          <Text.SmallMedium>{sitelink.text || t('Untitled sitelink')}</Text.SmallMedium>
          <Text.SmallRegular className={styles.url} truncate={false}>
            {sitelink.url}
          </Text.SmallRegular>
        </Flex>
      ))}
    </Stack>
  );
}

export default AdGroupSitelinks;
